// src/utils/threadUtils.js

/**
 * 受け取ったスレッド一覧を年ごとにグループ化
 * @param {Array} threads - Firestoreから取得したスレッド配列
 * @returns {Object} { 2025: [...], 2024: [...], ... }
 */
export const groupThreadsByYearMonth = (threads) => {
  const grouped = {};

  threads.forEach((thread) => {
    if (!thread.createdAt) return;
    const date = thread.createdAt.toDate();
    const key = `${date.getFullYear()}年${date.getMonth() + 1}月`; // 月は0スタートなので +1

    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(thread);
  });

  return grouped;
};

// src/utils/threadUtils.js

/**
 * スレッド一覧をカテゴリごとにグループ化
 * @param {Array} threads - Firestoreから取得したスレッド配列
 * @returns {Object} { "アンカー": [...], "その他": [...], ... }
 */
export const groupThreadsByCategory = (threads) => {
  const grouped = {};

  threads.forEach((thread) => {
    const category = thread.category || "未分類";
    if (!grouped[category]) grouped[category] = [];
    grouped[category].push(thread);
  });

  return grouped;
};

